import { Action } from 'redux';
import { Health } from '../../models/health';
import { APIError } from '../../helpers/types';
import { PayloadUserProfile, CreateProfileResult } from '../../models/profile';

export enum HealthActionTypes {
  ACTION_HEALTH_INIT = 'HEALTH_INIT',
  ACTION_BASIC_HEALTH_SUBMIT = 'BASIC_HEALTH_SUBMIT',
  ACTION_BASIC_HEALTH_SUBMIT_SUCCESS = 'BASIC_HEALTH_SUBMIT_SUCCESS',
  ACTION_BASIC_HEALTH_SUBMIT_ERROR = 'BASIC_HEALTH_SUBMIT_ERROR',
}
export interface ActionHealthInit extends Action {
  type: HealthActionTypes.ACTION_HEALTH_INIT;
  payload: Health;
}
export interface ActionBasicHealthSubmit extends Action {
  type: HealthActionTypes.ACTION_BASIC_HEALTH_SUBMIT;
  payload: PayloadUserProfile;
}
export interface ActionBasicHealthSubmitSuccess extends Action {
  type: HealthActionTypes.ACTION_BASIC_HEALTH_SUBMIT_SUCCESS;
  payload: CreateProfileResult;
}

export interface ActionBasicHealthSubmitError extends Action {
  type: HealthActionTypes.ACTION_BASIC_HEALTH_SUBMIT_ERROR;
  error: APIError;
}

export type HealthActions =
  | ActionHealthInit
  | ActionBasicHealthSubmit
  | ActionBasicHealthSubmitSuccess
  | ActionBasicHealthSubmitError
  ;